import { createSelector } from '@reduxjs/toolkit';

const selectAppointmentFirstMode = (state: any) => state.session.appointmentFirstMode;
const selectAppointmentReservation = (state: any) => state.appointment.reservation;

// Whether a reserved slot is in context, regardless of how far patient selection has progressed.
// Deliberately independent of the active patient: selecting one is a step within the handoff, not
// the end of it.
export const selectAppointmentFirstReservationInContext = createSelector(
	[selectAppointmentFirstMode, selectAppointmentReservation],
	(appointmentFirstMode, reservation) => !!(appointmentFirstMode && reservation?.flexCalendarEntryId),
);
